module.exports = __webpack_public_path__ + "static/img/RO@2x.f104bef7.jpg";